import type { NetworkingFacet } from './types'

export default function prepareNestedOptionGroups(options: NetworkingFacet[]) {
  return (
    options
      .filter((option) => !option.parentId)
      .map((option) => {
        return {
          option: { text: option.name, value: option.id },
          options: options.filter((o) => o.parentId?.toString() === option.id.toString()).map((o) => ({ text: o.name, value: o.id })) ?? [],
        }
      }) ?? []
  )
}
